import DataTableCellField from "@/components/data-table/components/DataTableCellField";
import { DirtyAwareCell } from "@/contexts/FormTableCellDirtyContext";
import { PayrollAggregate } from "@/types/payrollAggregate";
import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createTaxStatusFinal } from "../columns";

export const usePayrollAggregateColumnOverrides = (): Record<
  string,
  ColumnDef<PayrollAggregate>
> => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      deduction: {
        id: "deduction",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.deduction`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      addition: {
        id: "addition",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.addition`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      administrative_fee: {
        id: "administrative_fee",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.administrative_fee`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      deduction_percentage: {
        id: "deduction_percentage",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.deduction_percentage`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      permanent_comment: {
        id: "permanent_comment",
        meta: {
          allowColumnToBeALink: false,
        },
      },
      comment: {
        id: "comment",
        header: "payrolls.fields.comment_aggregate",
        cell: ({ row }) => {
          const fieldPath = `entries.${row.original.id}.comment`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} />
            </DirtyAwareCell>
          );
        },
        meta: {
          allowColumnToBeALink: false,
        },
      },
      tax_status_final: createTaxStatusFinal(t),
    }),
    [t],
  );
};
